import { AppRecoveryBoundary } from "./components/app-recovery";
import { installErrorDiagnostics } from "./lib/diagnostics";
import ReactDOM from "react-dom/client";
import "@fontsource-variable/instrument-sans/wght.css";
import "@fontsource/ibm-plex-mono/latin-500.css";
import "@fontsource/ibm-plex-mono/latin-600.css";
import App from "./App";
import { BackgroundPhotoUploads } from "./components/photo-upload-activity";
import { DesignSystemPreview } from "./components/ui/design-system-preview";
import "./styles.css";
import "./channel-management.css";
import "./import-listing-flow.css";
import "./workflow-feedback.css";

installErrorDiagnostics();

ReactDOM.createRoot(document.getElementById("root")!).render(
  import.meta.env.DEV && window.location.pathname === "/__design-system"
    ? <DesignSystemPreview />
    : <AppRecoveryBoundary><App /><BackgroundPhotoUploads /></AppRecoveryBoundary>
);

if ("serviceWorker" in navigator && import.meta.env.PROD) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {
      // The app remains fully usable without the offline cache.
    });
  });
}
